import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
    Card, CardContent, Typography, Grid, Divider, Box, Checkbox, Alert, LinearProgress,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
    Button, FormControl, InputLabel, MenuItem, Select, Stack
} from '@mui/material';
import moment from "moment";
import { FiniquitoService } from '../../services/finiquitoService';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Swal from 'sweetalert2';
import html2pdf from 'html2pdf.js';
import Cookies from 'universal-cookie'

const Finiquitar = ({ setHide }) => {
    const cookies = new Cookies();    
    const dispatch = useDispatch()
    const _TAB = useSelector((store) => store.tab)
    const general = useSelector((store) => store.general)

    const [servicios, setServicios] = useState([])
    const [total, setTotal] = useState('$ ')
    const [atencion, setAtencion] = useState({ Atendidopor: '', FechaAtencion: '', NombrePagador: '', RutPagador: '', TelefonoPagador: '', EmailPagador: '', RegionPagador: '', DireccionPagador: '' })
    const [formatos, setFormatos] = useState([]);
    const [causas, setCausas] = useState([]);
    const [finiquito, setFiniquito] = useState(null);
    const [cuotasMan, setCuotasMan] = useState([])
    const [cuotasShow, setCuotasShow] = useState(false)
    const [finiquitado, setFiniquitado] = useState(false);

    const [formatoSeleccionado, setFormatoSeleccionado] = useState('');
    const [htmlSeleccionado, setHtmlSeleccionado] = useState('');

    const getFiniquito = async (contractId) => {
        var _f = await FiniquitoService.FiniquitoContrato(contractId)
        if (_f && typeof _f === 'object') {
            setFiniquito(_f)
            setFormatoSeleccionado(_f.codeTemplate)
            setHtmlSeleccionado(_f.html)

            var x = getCausas(contractId, _TAB?.contractFull?.negocios[0].lineId, _f.casesCanceled);
            // Obtencion de causas
        } else {
            var x = getCausas(contractId, _TAB?.contractFull?.negocios[0].lineId, null);
        }

        return _f
    }

    useEffect(() => {
        var _f = null
        if (_TAB?.contractFull.contractId) {
            _f = getFiniquito(_TAB?.contractFull.contractId)
        }

        // informacion atencion
        //
        if (_TAB?.contractFull?.pagador) {

            setAtencion({
                Atendidopor: '',
                FechaAtencion: _TAB?.interview?.fecha ? moment(_TAB.interview.fecha).format("DD-MM-YYYY HH:mm:ss") : '',
                NombrePagador: _TAB.contractFull.pagador.firstName + " " + _TAB.contractFull.pagador.lastName,
                RutPagador: _TAB.contractFull.pagador.identifier,
                TelefonoPagador: _TAB.contractFull.pagador.telephone,
                EmailPagador: _TAB.contractFull.pagador.email,
                //RegionPagador: _TAB.contractFull.pagador.,
                DireccionPagador: _TAB.contractFull.pagador.address
            })

        }
        // 
        // fin informacion atencion

        // servicios contratados
        //
        var list = _TAB?.contractFull?.negocios?.flatMap((negocio) =>
            negocio.servicios.map((servicio) => ({
                lineaNegocio: negocio.name,
                servicio: servicio.name,
                costo: servicio.costo,
            }))
        )
        setServicios(list)
        setTotal(list.reduce((acc, s) => acc + s.costo, 0))
        //
        // fin servicios contratados

        if (_TAB.contractFull?.finiquitado) {
            setFiniquitado(_TAB.contractFull.finiquitado ?? false)
        }
        //<Alert className='mb-4' severity="warning" hidden={!finiquitado}>Contrato Finiquitado.</Alert>
    }, [_TAB])


    const getCausas = async (contractId, lineId, casesCanceled) => {
        var data = await FiniquitoService.ListCausas(contractId)
        if (Array.isArray(data)) {
            var prev = data.map(item => ({ ...item, finiquitar: false }))
            if (casesCanceled) {
                const ids = JSON.parse(casesCanceled);
                prev = prev.map(item => ids.includes(item.caseIdLegal) ? { ...item, finiquitar: true } : item);
            }
            setCausas(prev)
        }

        var templates = await FiniquitoService.ListTemplateFiniquito(lineId)
        if (Array.isArray(templates)) {
            setFormatos(templates)
        }
        ///////
        var cuotas = await FiniquitoService.CuotasPendientes(_TAB.contractFull.pagador.identifier, _TAB.contractFull.negocios[0].codCtto)
        setCuotasShow(true)
        setCuotasMan(cuotas)
        return "fin"
    }

    // causas asociadas
    const handleToggle = (index) => {
        const updatedCausas = [...causas];
        updatedCausas[index].finiquitar = !updatedCausas[index].finiquitar;
        setCausas(updatedCausas);
    };
    //fin causas asociadas

    //template contratos

    const handleChange = (event) => {
        const codigo = event.target.value;
        const selected = formatos.find(f => f.code === codigo);
        setFormatoSeleccionado(codigo);
        setHtmlSeleccionado(selected?.html || '');
    };
    //fin template contratos

    //tag htmlSeleccionado
    useEffect(() => {
        if (htmlSeleccionado == null || htmlSeleccionado == "") return;

        var _f = extraerFecha(new Date()/*_TAB.interview.fecha*/) || ""
        var customerF = _TAB.customerFormatted
        var Sucursales = _TAB.Sucursales
        var contractFull = _TAB.contractFull
        var interview = _TAB.interview

        var pagador = _TAB.contractFull.pagador

        var texto = htmlSeleccionado

        texto = texto.replace(/@dia_entrevista/g, _f.dia?.trim() || "@dia_entrevista")
        texto = texto.replace(/@mes_entrevista/g, _f.mesTexto?.trim() || "@mes_entrevista")
        texto = texto.replace(/@anio_entrevista/g, _f.año?.trim() || "@anio_entrevista")
        texto = texto.replace(/@sucursal/g, Sucursales?.find(x => x.id == customerF.sucursal)?.name || "@sucursal")
        texto = texto.replace(/@codigo_contrato/g, contractFull.negocios[0].codCtto.trim() || "@codigo_contrato")
        texto = texto.replace(/@nombre_pagador/g, `${pagador?.firstName?.trim() || ""} ${pagador?.lastName?.trim() || ""}`.trim() || "@nombre_pagador")
        texto = texto.replace(/@rut_pagador/g, pagador?.identifier?.trim() || "@rut_pagador")
        texto = texto.replace(/@telefono_pagador/g, pagador?.telephone?.trim() || "@telefono_pagador")
        texto = texto.replace(/@ocupacion_pagador/g, pagador?.ocupacion?.trim() || "@ocupacion_pagador")
        texto = texto.replace(/@ocupacion_pagaddor/g, pagador?.ocupacion?.trim() || "@ocupacion_pagaddor")
        texto = texto.replace(/@direccion_pagador/g, pagador?.address?.trim() || "@direccion_pagador")
        texto = texto.replace(/@email_pagador/g, pagador?.email?.trim() || "@email_pagador")
        texto = texto.replace(/@celular_pagador/g, pagador?.telephone?.trim() || "@celular_pagador")
        texto = texto.replace(/@estado_civil_pagador/g, general.estadoCivil?.find(x => x.id == pagador?.idEstadoCivil)?.name?.trim() || "@estado_civil_pagador")
        texto = texto.replace(/@comuna_pagador/g, general.comunas?.find(x => x.id == pagador?.idDistrito)?.description?.trim() || "@comuna_pagador")
        texto = texto.replace(/@comuna_pagado/g, general.comunas?.find(x => x.id == pagador?.idDistrito)?.description?.trim() || "@comuna_pagado")
        texto = texto.replace(/@region_pagador/g, general.regiones?.find(x => x.id == pagador?.idRegion)?.description?.trim() || "@region_pagador")

        texto = texto.replace(/@tipo_fuente/g, (interview.origen?.trim() ?? "Remoto") || "@tipo_fuente")
        texto = texto.replace(/@firmas/g, "")//"@firmas"
        texto = texto.replace(/@nacionalidad/g, general.paises?.find(x => x.id == pagador?.idCountry)?.description?.trim() || "@nacionalidad")
        texto = texto.replace(/@nacionalidad_pagador/g, general.paises?.find(x => x.id == pagador?.idCountry)?.description?.trim() || "@nacionalidad_pagador")
        /*
        var cuotas = linesOfBusiness[index].cuotas.length > 0 ? generarTablaCuotas(linesOfBusiness[index].cuotas[0]?.pagoCuotas) : ''
        var acreedores = generarTablaAcreedores(index)
        let totalAmount = `$ ${linesOfBusiness[index].contractServices.reduce((total, service) => total + (service.amount || 0), 0)}` || ""

        texto = texto.replace(/@origen/g, _TAB.interview?.origen?.toUpperCase().trim() || "REMOTO")
        texto = texto.replace(/@porcentajes/g, "@porcentajes")
        texto = texto.replace(/@cuotas/g, cuotas?.trim() || "@cuotas")
        texto = texto.replace(/@acreedores/g, acreedores || "@acreedores")
        texto = texto.replace(/@defensavictimas/g, "@defensavictimas")
        texto = texto.replace(/@fecha_texto_fin/g, "@fecha_texto_fin")
        texto = texto.replace(/@fecha_act_texto/g, "@fecha_act_texto")
        texto = texto.replace(/@h_acreedores/g, "@h_acreedores")
        texto = texto.replace(/@defensafamilia/g, "@defensafamilia")
        texto = texto.replace(/@nombre_empresa_pyme/g, "@nombre_empresa_pyme")
        texto = texto.replace(/@defensafamilias/g, "@defensafamilias")
        texto = texto.replace(/@servicios/g, "@servicios")
        texto = texto.replace(/@total_ccontrato/g, totalAmount.trim() || "@total_ccontrato")
        texto = texto.replace(/@toral_contrato/g, totalAmount.trim() || "@toral_contrato")
        texto = texto.replace(/@total_contrato/g, totalAmount.trim() || "@total_contrato")
        texto = texto.replace(/@fi/g, "@fi")
        */
        if (texto != htmlSeleccionado)
            setHtmlSeleccionado(texto)

    }, [htmlSeleccionado])

    const extraerFecha = (fechaContrato) => {
        let fecha = new Date(fechaContrato);

        let dia = fecha.getDate().toString().trim() || "<span style='background-color:orange'>@dia_entrevista</span>";

        let meses = ["enero", "febrero", "marzo", "abril", "mayo", "junio",
            "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
        let mesTexto = meses[fecha.getMonth()].trim() || "<span style='background-color:orange'>@mes_entrevista</span>";

        let año = fecha.getFullYear().toString().trim() || "<span style='background-color:orange'>@año_entrevista</span>";

        return { dia, mesTexto, año };
    }
    //fin tag htmlSeleccionado

    const handleFiniquitar = async () => {

        if (cuotasMan.length == 0) {

            const result = await Swal.fire({
                title: 'Esta finiquitando un contrato sin cuotas activas',
                text: '¿Deseas continuar con esta acción?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sí, continuar',
                cancelButtonText: 'Cancelar',
            });

            if (!result.isConfirmed) return;
        }

        var sfire = Swal.fire({
            title: 'Finiquitando, espere un momento ...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        })

        var data = {
            contractId: _TAB?.contractFull.contractId,
            html: htmlSeleccionado,
            code: formatoSeleccionado,
            cases: causas.filter(item => item.finiquitar === true).map(item => item.caseIdLegal),
            rut: _TAB.contractFull?.pagador?.identifier || "",//_TAB.contractFull?.rut ?? "",
            codCtto: _TAB.contractFull?.negocios[0].codCtto ?? "",
            siglas: _TAB.contractFull?.negocios[0].siglas ?? "",
            sucursal: _TAB.Sucursales?.find(x => x.id == _TAB?.customerFormatted?.sucursal)?.description ?? "",
            conCuotas : cuotasMan.length > 0 ? true : false,
        }
        var _fin = await FiniquitoService.StartFiniquito(data)

        setFiniquito(await getFiniquito(_TAB?.contractFull.contractId))
        setTimeout(() => {
            var message = ""
            var icon = "success"

            if (_fin.success) {
                icon = "success"
                message = "Contrato finiquitado correctamente"
                if (_fin.old)
                    message = "Contrato finiquitado con anterioridad"
            } else {
                icon = "warning"
                message = "Contrato con errores:"
                if (!_fin.legal && !_fin.manager)
                    message = "Contrato no finiquitado:"
                if (!_fin.legal)
                    message += "<p>Error en causas</p>"
                if (!_fin.manager)
                    message += "<p>Error en cuotas</p>"
                message += "<p>Contacte a tecnologia@grupodefensa.cl</p>"
            }
            sfire.close();
            Swal.fire({
                position: "center",
                icon: icon,
                title: message,
                showConfirmButton: true,
            });
        }, 500);


    }

    const ShowPDF = async () => {
        const tempElement = document.createElement('div')
        tempElement.innerHTML = htmlSeleccionado
        //document.body.appendChild(tempElement)

        const opt = {
            margin: 10,
            filename: 'Finiquito.pdf',
            image: { type: 'jpeg', quality: 0.6 },
            html2canvas: { scale: 1, useCORS: true },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        };

        try {
            await html2pdf().set(opt).from(tempElement).save()
        } catch (error) {
            console.error('Error al convertir a PDF:', error)
        }
    }

    return (
        <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '40px', p: 4 }} >

            <Card sx={{ /*maxWidth: 700, margin: 'auto', mt: 4,*/ boxShadow: 3 }}>
                <CardContent >
                    <Box display="flex" justifyContent="space-between" alignItems="center" /*sx={{ backgroundColor: '#a693ea'}}*/>
                        <Typography variant="h5" gutterBottom>
                            Preparacion Finiquito
                        </Typography>
                        <Button variant='outlined' onClick={() => setHide()}>Volver</Button>
                    </Box>

                    <Alert className='mt-2 mb-4' severity="warning" hidden={!finiquitado}>Contrato Finiquitado.</Alert>

                    <Divider sx={{ mb: 2 }} />

                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Typography><strong>Atendido por:</strong> {atencion.Atendidopor}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Typography><strong>Fecha Atención:</strong> {atencion.FechaAtencion}</Typography>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Typography><strong>Nombre:</strong> {atencion.NombrePagador}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography><strong>RUT:</strong> {atencion.RutPagador}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography><strong>Email:</strong> {atencion.EmailPagador}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography><strong>Teléfono:</strong> {atencion.TelefonoPagador}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} hidden>
                            <Typography><strong>Región:</strong> {atencion.RegionPagador ?? ''}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography><strong>Dirección:</strong> {atencion.DireccionPagador}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography><strong>Monto Acordado Contrato: </strong> {total.toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}</Typography>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            <TableContainer component={Paper} sx={{ boxShadow: 3, mt: 4 }}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: '#C8BFE7' }}>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>LINEA DE NEGOCIO</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>SERVICIO</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>COSTO SERVICIO</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {servicios.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell>{row.lineaNegocio}</TableCell>
                                <TableCell>{row.servicio}</TableCell>
                                <TableCell>{row.costo.toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}</TableCell>
                            </TableRow>
                        ))}
                        <TableRow>
                            <TableCell colSpan={2}></TableCell>
                            <TableCell>
                                <Typography sx={{ fontWeight: 'bold' }}>: Total Servicios</Typography>
                                <Typography>{total.toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}</Typography>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>

            <TableContainer component={Paper} sx={{ boxShadow: 3,/*  maxHeight: 300, */mt: 4 }}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: '#C8BFE7' }}>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>ID CASE</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>TITULO CASE</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>FINIQUITAR</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {causas.map((row, index) => (
                            <TableRow key={row.caseIdLegal}>
                                <TableCell>{row.caseIdLegal}</TableCell>
                                <TableCell>{row.title}</TableCell>
                                <TableCell>
                                    <Checkbox
                                        checked={row.finiquitar}
                                        onChange={() => handleToggle(index)}
                                        disabled={finiquitado}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>


            <TableContainer component={Paper} sx={{ boxShadow: 3, height: 400, mt: 4, pb: 1 }} hidden={finiquitado}>
                <LinearProgress hidden={cuotasShow} />
                <Table hidden={cuotasMan.length == 0}>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: '#C8BFE7' }}>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Numero Cuota</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Fecha Vencimiento</TableCell>
                            <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Monto</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody >
                        {cuotasMan.map((c, index) => (
                            <TableRow key={index}>
                                <TableCell>{c.numdoc}</TableCell>
                                <TableCell>{c.vencimiento}</TableCell>
                                <TableCell>{c.saldo.toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}</TableCell>
                            </TableRow>
                        ))}
                        <TableRow >
                            <TableCell></TableCell>
                            <TableCell>Total</TableCell>
                            <TableCell>{cuotasMan.reduce((sum, item) => sum + item.saldo, 0).toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>

                {!finiquitado && cuotasMan.length == 0 && cuotasShow ?
                    <Box sx={{ mt: 3, p: 2, width: '100%', textAlign: 'center', justifyContent: 'center', display: 'flex' }}>
                        <Box sx={{ p: 2, width: '50%', textAlign: 'center' }}>
                            <Box sx={{ p: 2, textAlign: 'center' }}>
                                <Typography gutterBottom variant="h4" >
                                    No se encontraron cuotas para finiquitar
                                </Typography>
                                <Typography gutterBottom variant="h6" >
                                    Revise el portal de cuotas antes de continuar
                                </Typography>
                            </Box>

                            <Box sx={{ p: 2, textAlign: 'center' }}>
                                <Stack direction="row" justifyContent="center" spacing={1}>
                                    <Button size='large' variant="contained" color="primary" onClick={() => window.open('http://172.16.10.45:3019/', '_blank', 'noopener,noreferrer')}> Revisar Cuotas </Button>
                                </Stack>
                            </Box>
                        </Box>
                    </Box> : null}


            </TableContainer>



            <Box sx={{ mt: 3, p: 3, background: 'white', mt: 4 }}>
                <Typography variant="h5" sx={{ mb: 2 }} gutterBottom> Finiquito</Typography>
                <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel id="formato-label">Formatos</InputLabel>
                    <Select
                        disabled={finiquitado}
                        labelId="formato-label"
                        value={formatoSeleccionado}
                        label="Formatos de contratos"
                        onChange={handleChange}
                    >
                        <MenuItem value="">
                            <em>Seleccionar...</em>
                        </MenuItem>
                        {formatos.map((formato) => (
                            <MenuItem key={formato.id} value={formato.code}>
                                {formato.code} -- {formato.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {htmlSeleccionado && (<ReactQuill readOnly={finiquitado} theme="snow" value={htmlSeleccionado} onChange={setHtmlSeleccionado} />)}
                <Button sx={{ mt: 3 }} className='me-3' variant='outlined' onClick={() => ShowPDF()} hidden={!(finiquitado || (finiquito && finiquito.status == "1"))}>Descargar</Button>
                {/* <Button sx={{ mt: 3, ms: 3 }} variant='outlined' onClick={() => handleFiniquitar()} disabled={finiquitado || (finiquito && finiquito.status == "1")}>{(finiquitado || (finiquito && finiquito.status == "1")) ? "Contrato finiquitado" : "Finiquitar"}</Button> */}
                {window.ROLID_FINIQUITA.includes(parseInt(cookies.get('rolId'), 10)) /*cookies.get('rolId') == window.ROLID_FINIQUITA*/ && (
                <Button
                    sx={{ mt: 3, ms: 3 }}
                    variant='outlined'
                    onClick={() => handleFiniquitar()}
                    disabled={finiquitado || (finiquito && finiquito.status=="1")}
                >
                    {(finiquitado || (finiquito && finiquito.status=="1")) 
                    ? "Contrato finiquitado"
                    : "Finiquitar"
                    }
                </Button>
                )}            
            </Box>
        </Box>
    )
}

export default Finiquitar

/*
REEMPLAZAR TAGS
SELECCIONAR CAUSAS Y  DESACTIVAR EN LEGAL
QUITAR CUOTAS EN MANAGER
ENVIAR CORREO??
*/
